import { API_ENDPOINTS } from 'data';
import client from './axiosClient';

// ✅ Updated NewInvoice interface to match the backend schema
export interface NewInvoice {
	clientId: number;
	startDate: string;
	endDate: string;
	assignmentRole: string;
	grossAmount: number;
	currency: string;
	hours: number;
	timeRate: number;
	paymentTerms: string;
	shippingDate: string;
	invoiceText: string;
	note: string;
	amountInclVAT: number;
	invoiceType: string;
	contactEmail?: string;
}

// ✅ Optional: Define full Invoice interface for responses
export interface Invoice extends NewInvoice {
  id: number;
  invoiceDocId?: number;
  payslipDocId?: number;
  createdAt: string;
  updatedAt: string;
}

export const getInvoices = async (page = 1, per_page = 10) => {
  return client.get(API_ENDPOINTS.INVOICES.GET, {
    params: { page, per_page },
  });
};

export const createInvoice = async (invoiceData: NewInvoice) => {
  return client.post(API_ENDPOINTS.INVOICES.CREATE, invoiceData);
};

// ✅ Update type for updateInvoice to use Partial<Invoice>
export const updateInvoice = async (invoiceData: Partial<Invoice>) => {
  return client.put(`${API_ENDPOINTS.INVOICES.UPDATE}/${invoiceData.id}`, invoiceData);
};

export const deleteInvoice = async (invoiceId: number) => {
  return client.delete(`${API_ENDPOINTS.INVOICES.DELETE}/${invoiceId}`);
};

export const getInvoiceById = async (invoiceId: number) => {
  return client.get(`${API_ENDPOINTS.INVOICES.GET}/${invoiceId}`);
};

export const updateInvoiceStatus = async (req: any) => {
	return client.put(`${API_ENDPOINTS.INVOICES.UPDATE}/${req.id}/update-status`, req);
};

export const downloadInvoiceDocById = async (docId: number) => {
  return client.get(`${API_ENDPOINTS.INVOICES.DOWNLOAD_DOC}/${docId}/download`);
};

export const saveInvoiceDocDownload = async (
  docId: number,
  fallbackFilename: string,
) => {
  const response = await downloadInvoiceDocById(docId);
  const { data } = response;
  const filename = data.filename || fallbackFilename;
  const base64 = typeof data.data === 'string' ? data.data.trim() : '';
  const blob = await fetch(`data:application/octet-stream;base64,${base64}`).then(
    (res) => res.blob(),
  );

  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
